var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'SystemSettingsHome'
      }
    }
  }, [_vm._v("全系統管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'SystemSuiteList'
      }
    }
  }, [_vm._v("系統方案管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center justify-content-between"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "系統方案名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "name", $$v);
      },
      expression: "state.form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "系統方案代碼",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "code",
      "type": "text",
      "state": _vm.v$.form.code.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "code", $$v);
      },
      expression: "state.form.code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.code.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _vm.isShow ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "系統方案編號",
      "label-for": "code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "value": _vm.state.form.id,
      "disabled": ""
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "is_enabled",
      "value": 1,
      "unchecked-value": 0,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "is_enabled", $$v);
      },
      expression: "state.form.is_enabled"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.isShow ? '返回' : '取消'))]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }